<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as PHONE_TYPOLOGY_TYPES } from './store'
import { ROUTES as PHONE_TYPOLOGY_ROUTES } from './router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import PhoneTypologyTable from './PhoneTypologyTable'
import PhoneTypologyCommonFilters from './PhoneTypologyCommonFilters'
import PhoneTypologyEdit from './PhoneTypologyEdit.vue'

export default {
  name: 'PhoneTypologyList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': PhoneTypologyTable,
    'common-filters': PhoneTypologyCommonFilters,
    'component-edit': PhoneTypologyEdit,
    'component-detail': PhoneTypologyEdit
  },
  data () {
    return {
      PHONE_TYPOLOGY_ROUTES,
      title: this.$t('Phone typologies'),
      rolePerm: ['organization_phonetypology_list'],
      actionEnablePermission: ['organization_phonetypology_enable'],
      actionDisablePermission: ['organization_phonetypology_disable'],
      searchFields: [
        { key: 'filter__code__icontains', placeholder: this.$t('Code'), type: 'text', col: 4 },
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 4 },
        { key: 'filter__slug__icontains', placeholder: this.$t('Slug'), type: 'text', col: 4 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      ...PHONE_TYPOLOGY_TYPES.GENERIC.organization.phonetypology.LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.PHONE_TYPOLOGY_ROUTES.PHONE_TYPOLOGY_LIST
    },
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('organization_phonetypology_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: PHONE_TYPOLOGY_TYPES.GENERIC.organization.phonetypology.LIST.MUTATIONS.setSelectedList,
      setSelectAll: PHONE_TYPOLOGY_TYPES.GENERIC.organization.phonetypology.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...PHONE_TYPOLOGY_TYPES.GENERIC.organization.phonetypology.LIST.ACTIONS
    })
  }
}
</script>
